/* ============================================================================
   component-quickadd-mobile.js  (2026-09-02, by🔥Pista)
   Botão único de adicionar (.pista-quickadd-btn) nos cards com variação:
   - Mobile/touch: abre uma FOLHA INFERIOR com os seletores de variação.
   - Desktop (mouse real): abre uma SIDEBAR À DIREITA, no mesmo lugar e no
     mesmo estilo do carrinho lateral do tema — inclusive reaproveitando o
     MESMO elemento `.background-overlay` (com a classe `.hold`) que o
     carrinho já usa para escurecer o site, em vez de reinventar um backdrop
     próprio. Isso garante consistência visual com o resto da loja.
   Em ambos os casos: seleciona variação, mostra preço completo (Pix/parcelas)
   e adiciona ao carrinho via /cart/add.js sem sair da página.
   ============================================================================ */
(function () {
  if (window.PistaQuickAddMobileInitialized) return;
  window.PistaQuickAddMobileInitialized = true;

  function isMobile() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches
        || window.matchMedia('(max-width: 1024px)').matches;
  }

  var panelEl = null;
  var currentMode = null; /* 'sheet' (mobile) | 'sidebar' (desktop) */

  function closePanel() {
    if (panelEl) {
      panelEl.remove();
      panelEl = null;
    }
    document.body.classList.remove('pista-quickadd-open', 'pista-desktop-sidebar-open');
    currentMode = null;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : count;
    });
  }

  /* Abre o carrinho lateral NATIVO do tema (não um painel nosso) clicando de
     verdade no ícone [data-cart-sidebar] do header. Isso reaproveita 100% da
     lógica do theme.js (Shopify.getCart + halo.updateSidebarCart + classe
     cart-sidebar-show no body) sem duplicar nada — garante que o conteúdo
     do drawer sempre vem atualizado, igual clicar no ícone manualmente. */
  function openSiteCartDrawer() {
    var cartIcon = document.querySelector('[data-cart-sidebar]');
    if (cartIcon) {
      cartIcon.click();
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function buildPriceHtml(variant) {
    var cfg = window.pistaCardPricing || { pixEnabled: true, pixDiscountPercent: 5, installments: 10 };
    var price = variant.price;
    var installmentPrice = price / cfg.installments;

    if (cfg.pixEnabled) {
      var pixPrice = price * (100 - cfg.pixDiscountPercent) / 100;
      return (
        '<div class="pista-qa-price-pix">' + formatMoney(pixPrice) +
          ' <span class="pista-qa-price-pix-label">no Pix</span>' +
          ' <span class="pista-qa-price-off">-' + cfg.pixDiscountPercent + '%</span>' +
        '</div>' +
        '<div class="pista-qa-price-installments">ou ' + formatMoney(price) +
          ' em ' + cfg.installments + 'x de <strong>' + formatMoney(installmentPrice) + '</strong> sem juros</div>'
      );
    }

    return (
      '<div class="pista-qa-price-pix">' + formatMoney(price) + '</div>' +
      '<div class="pista-qa-price-installments">ou ' + cfg.installments + 'x de <strong>' + formatMoney(installmentPrice) + '</strong> sem juros</div>'
    );
  }

  function buildOptionSelectors(product) {
    var wrap = document.createElement('div');
    wrap.className = 'pista-qa-options';

    var selects = [];

    product.options.forEach(function (optionRaw, i) {
      /* Shopify /products/{handle}.js retorna `options` como array de
         strings OU de objetos {name, values} dependendo da versão/loja —
         cobrimos os dois formatos aqui (bug real: "[object Object]"). */
      var optionName = (optionRaw && typeof optionRaw === 'object') ? optionRaw.name : optionRaw;

      var values = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (i + 1)];
        if (val && values.indexOf(val) === -1) values.push(val);
      });

      var group = document.createElement('div');
      group.className = 'pista-qa-option-group';

      var label = document.createElement('span');
      label.className = 'pista-qa-option-label';
      label.textContent = optionName + ' ';
      group.appendChild(label);

      if (values.length <= 1) {
        /* Só um valor possível (ex: "Cor Branco") — mostra como texto,
           igual ao exemplo da Decathlon, sem dropdown desnecessário. */
        var valueText = document.createElement('span');
        valueText.className = 'pista-qa-option-value';
        valueText.textContent = values[0] || '';
        group.appendChild(valueText);

        var hiddenSelect = document.createElement('select');
        hiddenSelect.hidden = true;
        hiddenSelect.dataset.optionIndex = i;
        var opt = document.createElement('option');
        opt.value = values[0] || '';
        opt.textContent = values[0] || '';
        hiddenSelect.appendChild(opt);
        group.appendChild(hiddenSelect);
        selects.push(hiddenSelect);
      } else {
        group.classList.add('has-select');
        var select = document.createElement('select');
        select.className = 'pista-qa-select';
        select.dataset.optionIndex = i;
        values.forEach(function (val) {
          var opt2 = document.createElement('option');
          opt2.value = val;
          opt2.textContent = val;
          select.appendChild(opt2);
        });
        group.appendChild(select);
        selects.push(select);
      }

      wrap.appendChild(group);
    });

    return { wrap: wrap, selects: selects };
  }

  function findVariant(product, selects) {
    var chosen = selects.map(function (s) { return s.value; });
    return product.variants.find(function (v) {
      return chosen.every(function (val, i) { return v['option' + (i + 1)] === val; });
    });
  }

  /* Monta o conteúdo comum (imagem, título, preço, opções, botões) dentro
     de um container já existente — usado tanto pela folha mobile quanto
     pela sidebar desktop. */
  function buildPanelContent(container, product, triggerBtn) {
    var img = (product.featured_image && product.featured_image) || (product.images && product.images[0]) || '';
    var built = buildOptionSelectors(product);

    container.innerHTML =
      '<button type="button" class="pista-qa-close" data-qa-close aria-label="Fechar">&times;</button>' +
      '<div class="pista-qa-head">' +
        (img ? '<img class="pista-qa-img" src="' + img + '" alt="" width="70" height="70">' : '') +
        '<div class="pista-qa-info">' +
          '<div class="pista-qa-title">' + product.title + '</div>' +
          '<div class="pista-qa-price"></div>' +
        '</div>' +
      '</div>';

    container.insertBefore(built.wrap, container.querySelector('.pista-qa-head').nextSibling);

    var actions = document.createElement('div');
    actions.className = 'pista-qa-actions';

    var buyBtn = document.createElement('button');
    buyBtn.type = 'button';
    buyBtn.className = 'pista-qa-buy-btn';
    buyBtn.textContent = 'Comprar agora';

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'pista-qa-add-btn';
    addBtn.textContent = 'Adicionar ao carrinho';

    var detailsLink = document.createElement('a');
    detailsLink.className = 'pista-qa-details-link';
    detailsLink.href = triggerBtn.href;
    detailsLink.textContent = 'Ver detalhes do produto';

    actions.appendChild(buyBtn);
    actions.appendChild(addBtn);
    actions.appendChild(detailsLink);
    container.appendChild(actions);

    var priceEl = container.querySelector('.pista-qa-price');

    function syncPrice() {
      var variant = findVariant(product, built.selects);
      if (variant) {
        priceEl.innerHTML = buildPriceHtml(variant);
        var disabled = !variant.available;
        buyBtn.disabled = disabled;
        addBtn.disabled = disabled;
        addBtn.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';
      }
    }

    built.selects.forEach(function (s) { s.addEventListener('change', syncPrice); });
    syncPrice();

    container.querySelectorAll('[data-qa-close]').forEach(function (el) {
      el.addEventListener('click', closePanel);
    });

    function addToCart(afterAdd) {
      var variant = findVariant(product, built.selects);
      if (!variant || !variant.available) return;

      addBtn.disabled = true;
      buyBtn.disabled = true;
      addBtn.textContent = 'Adicionando...';
      buyBtn.textContent = 'Adicionando...';

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (afterAdd === 'checkout') {
            window.location.href = '/checkout';
            return;
          }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateCartCount(cart.item_count);
            addBtn.textContent = 'Adicionado ✓';
            buyBtn.textContent = 'Comprar agora';
            closePanel();
            openSiteCartDrawer();
          });
        })
        .catch(function () {
          addBtn.disabled = false;
          buyBtn.disabled = false;
          addBtn.textContent = 'Tentar novamente';
          buyBtn.textContent = 'Comprar agora';
        });
    }

    addBtn.addEventListener('click', function () { addToCart('cart'); });
    buyBtn.addEventListener('click', function () { addToCart('checkout'); });
  }

  function openMobileSheet(product, triggerBtn) {
    closePanel();
    currentMode = 'sheet';

    panelEl = document.createElement('div');
    panelEl.className = 'pista-quickadd-sheet';
    panelEl.innerHTML = '<div class="pista-qa-panel" role="dialog" aria-modal="true"></div>';

    buildPanelContent(panelEl.querySelector('.pista-qa-panel'), product, triggerBtn);

    document.body.appendChild(panelEl);
    document.body.classList.add('pista-quickadd-open');

    var overlay = document.querySelector('.background-overlay');
    if (overlay) overlay.addEventListener('click', closePanel, { once: true });
  }

  function openDesktopSidebar(product, triggerBtn) {
    closePanel();
    currentMode = 'sidebar';

    panelEl = document.createElement('div');
    panelEl.className = 'pista-qa-sidebar';
    panelEl.setAttribute('role', 'dialog');
    panelEl.setAttribute('aria-modal', 'true');

    buildPanelContent(panelEl, product, triggerBtn);

    document.body.appendChild(panelEl);
    /* Mesmo padrão do carrinho lateral (body.<estado>-show .background-overlay):
       ver assets/component-quick-cart.css — a classe no body revela o overlay
       global via CSS, sem precisar de nenhum backdrop próprio. */
    document.body.classList.add('pista-desktop-sidebar-open');
    /* força reflow antes de adicionar a classe que desliza a sidebar pra dentro */
    void panelEl.offsetWidth;
    panelEl.classList.add('is-open');

    var overlay = document.querySelector('.background-overlay');
    if (overlay) {
      overlay.addEventListener('click', closePanel, { once: true });
    }
  }

  /* Produto SEM variação: clique já adiciona direto ao carrinho — nenhum
     formulário/modal no meio, é só um <button> simples. Antes disso passava
     pelo <form> nativo do tema (add-to-cart-form.liquid), que tinha uma
     estrutura HTML diferente do botão de produtos com variação e causava
     bugs de largura/estilo só nesse caso (form não acompanhava a largura do
     botão pai). Reaproveita a mesma função updateCartCount(). */
  function addDirectToCart(btn) {
    var variantId = btn.dataset.quickaddVariantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var originalHtml = btn.innerHTML;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        openSiteCartDrawer();
        setTimeout(function () {
          btn.disabled = false;
        }, 900);
      })
      .catch(function () {
        btn.innerHTML = originalHtml;
        btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var directBtn = e.target.closest('[data-quickadd-add-direct]');
    if (directBtn) {
      e.preventDefault();
      addDirectToCart(directBtn);
      return;
    }

    var btn = e.target.closest('[data-quickadd-has-variants]');
    if (!btn) return;

    e.preventDefault();
    var handle = btn.dataset.quickaddProduct;
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        if (isMobile()) openMobileSheet(product, btn);
        else openDesktopSidebar(product, btn);
      })
      .catch(function () { window.location.href = btn.href; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panelEl) closePanel();
  });
})();